import isHtml from 'is-html';
import {stringIsEnglish, isRightIpv4Andv6} from './utils';
import { isNil } from 'lodash';

const validatorMap = {
    'deviceName': validateDeviceName,
    'presetName': validatePresetName,
    'cabinetIPAddress': validateIpAddress,
    'pinCode': validatePinCode
};
const validResult = {isValid: true};

export const deviceValidator = (name, ...args) => {
    const {[name]: validators} = validatorMap;
    if(validators) {
        if(Array.isArray(validators)) {
            for(const validator of validators) {
                const result = validator(...args);
                if(!result.isValid) {
                    return result;
                }
            }
            return validResult;
        }
        return validators(...args);
    } else {
        return null;
    }
};

export function validatePinCode(prevVal, curVal) {
    let isValid = true;
    let messageId = undefined;
    if(!isNil(curVal) && !isNil(prevVal)) {
        if(prevVal.length !== curVal.length) {
            messageId = 'MESSAGE_DEVICE_CHECK_INPUT_CHAR_P';
            isValid = false;
        }
    }
    return {isValid, messageId};
}

export function parseDeviceSupportFlag(flag){
    const flagArr = (flag+'').split('');
    return {
        supportSWUpdateV2: (flagArr.length >= 1) && flagArr[0] === '1',
        supportStorageClean: (flagArr.length >= 2) && flagArr[1] === '1',
        supportLogCollect: (flagArr.length >= 3) && flagArr[2] === '1',
        supportUhdDisplay: (flagArr.length >= 4) && flagArr[3] === '1',
    }
};

export function validateDeviceName(name) {
    let message = undefined;
    let isValid = true;
    let messageId = undefined;

    if(!name || name.length < 1 || name.length > 50){
        messageId = 'MESSAGE_COMMON_MAX_50_P';
        isValid = false;
    } else {
       if(!stringIsEnglish(name)){
            messageId = 'MESSAGE_DEVICE_CHECK_INPUT_CHAR_P';
            message = isHtml(name) ? name : '';
            isValid = false;
       }
    }

    return {isValid, messageId, message};
}

function validatePresetName(name) {
    let messageId;
    let isValid = true;

    if(!/^[a-zA-Z0-9._ ]+$/.test(name)) {
        messageId = 'MIS_SID_ONLY_ALPHANUMERIC_CHARACTERS_AND_FOLLOWING_ALLOWED'
        isValid = false;
    }

    return {isValid, messageId};
}

export function validateNumbers(value){
    let messageId;
    let isValid = true;

    if( !/^\d+$/.test(value)){
        messageId = 'COM_SID_SIGANGE_CAN_ONLY_USE_NUMBER';
        isValid = false;
    }
    return {isValid, messageId};
}


export function validatePort(value){
    return !(value < 0 || value > 65536);
}

export function validateWhiteSpace(value){
    return /\s/.test(value);
}


export function validateIpAddress(value) {
    if(!isRightIpv4Andv6(value)) {
        return {isValid: false, messageId: 'MIS_TEXT_IP_ADDRESS_INCORRECT_P'};
    }

    return validResult;
}

export function validateProxyException(value) {
    return !/[\/*~&\\<>]/.test(value);
}